import cookie from 'react-cookies';

import { RequestDto } from '@r1-frontend/api-domru/core-requests/api/v1/call/back/dto/RequestDto';

import { getGaId } from '@r1-frontend/shared/helpers/getGaId';
import { getYmId } from '@r1-frontend/shared/helpers/getYmId';
import { IRequest } from '@r1-frontend/shared/types/IRequest';

/*
 * Заявка на обратный звонок (на сервере OMS)
 * @link https://master.core-requests.sandbox.d2c.r-one.io/docs#/%D0%97%D0%B0%D1%8F%D0%B2%D0%BA%D0%B8%20%D0%BD%D0%B0%20%D0%B7%D0%B2%D0%BE%D0%BD%D0%BE%D0%BA/CallsController_callBack
 */
export const backCall = (body: RequestDto): IRequest => {
    const clientId = cookie.load('_ga_cid');

    return {
        uri: '/api/v1/call/back',
        method: 'POST',
        body: JSON.stringify({
            ...body,
            gaCid: clientId ?? getGaId(),
            ...getYmId(),
        }),
        withProvider: true,
    };
};
